import { render, staticRenderFns } from "./AdminFactoryRequest.vue?vue&type=template&id=3f1ebe19&"
import script from "./AdminFactoryRequest.vue?vue&type=script&lang=js&"
export * from "./AdminFactoryRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports